import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import officeBearerService from "./officeBearerService"

const initialState = {
    bearers: [],
    isLoading: false,
    isError: false,
    currentPage: 1,
    lastPage: 1,
    perPage: 24,
    alumniDetails: {},
    nextPageURI: null,
    prevPageURI: null,
    pageContent: {},
}

export const fetchBearers = createAsyncThunk(
    "officeBearers/fetchBearers",
    async (currentPage, thunkAPI) => {
        try {
            const { getState } = thunkAPI
            const state = getState().officeBearersPage
            return await officeBearerService.fetchBearers(
                state.perPage,
                currentPage
            )
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const fetchPageContent = createAsyncThunk(
    "officeBearers/fetchPageContent",
    async (slug, thunkAPI) => {
        try {
            return await officeBearerService.fetchPageContent(slug)
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const officeBearersSlice = createSlice({
    name: "officeBearers",
    initialState,
    reducers: {
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBearers.pending, (state) => {
                state.isLoading = true
                state.bearers = []
            })
            .addCase(fetchBearers.fulfilled, (state, action) => {
                state.isLoading = false
                state.bearers = action.payload.data
                state.currentPage = action.payload.current_page
                state.lastPage = action.payload.last_page
                state.nextPageURI = action.payload.next_page_url
                state.prevPageURI = action.payload.prev_page_url
            })
            .addCase(fetchBearers.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.bearers = []
                state.currentPage = 1
                state.lastPage = 1
                state.nextPageURI = null
                state.prevPageURI = null
                state.errorMessage = action.payload
            })
            .addCase(fetchPageContent.fulfilled, (state, action) => {
                state.pageContent = action.payload
            })
            .addCase(fetchPageContent.rejected, (state) => {
                state.pageContent = {}
            })
    },
})

export const { setCurrentPage } = officeBearersSlice.actions
export default officeBearersSlice.reducer
